
export enum SiteInstallationStateEnum {
    PLANNED = 'PLANNED',
    INSTALLED = 'INSTALLED',
    COMPLETE = 'COMPLETE',
    ONGOING = 'ONGOING',
}
